import { fieldConfigs } from './config/fields';
import type { ConfigValue } from './config/ConfigStore';
import type { AppState } from './render';

export function parseValue(value: string, type: string): string | number | boolean {
  switch (type) {
    case 'number':
      return Number(value);
    case 'checkbox':
      return value === 'true';
    default:
      return value;
  }
}

export function handleFieldChange(app: AppState, fieldId: string, value: string): AppState {
  const fieldConfig = fieldConfigs.find((f) => f.register === fieldId);
  if (fieldConfig) {
    const typedValue = parseValue(value, fieldConfig.type);
    return { ...app, config: new Map(app.config).set(fieldConfig.register, typedValue) };
  }
  return app;
}
